module.exports = __webpack_public_path__ + "img/Photo_3___Construction_983_2_1.5a9c13ea.jpg";